import React from 'react';
import { Package } from 'lucide-react';
import { Button } from '../ui/button';

export const EmptyState = ({ onClearFilters }) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      <div className="w-20 h-20 rounded-full bg-muted flex items-center justify-center mb-6">
        <Package className="w-10 h-10 text-muted-foreground" />
      </div>
      <h3 className="text-xl font-semibold text-foreground mb-2">
        No products match your filters
      </h3>
      <p className="text-muted-foreground mb-6 max-w-md">
        Try adjusting your search criteria or clearing some filters to see more products.
      </p>
      <Button variant="outline" onClick={onClearFilters}>
        Clear All Filters
      </Button>
    </div>
  );
};
